import {parsePerseusItem} from "@khan/component-perseus";

/**
 * Returns true if the given value looks more like an Article than an Item.
 */
export function isProbablyArticle(value: unknown): boolean {
    if (value == null || typeof value !== "object") {
        return false;
    }
    return Array.isArray(value) || Object.hasOwn(value, "content");
}

/**
 * Validates Perseus item content and returns parsed data or null if invalid.
 */
export function validateDiagramContent(diagram: string): any | null {
    if (!diagram || diagram.trim().length === 0) {
        return null;
    }

    let rawObject: unknown;
    try {
        rawObject = JSON.parse(diagram);
    } catch (e) {
        // Invalid JSON, return null
        return null;
    }

    // We only support items, not articles
    if (isProbablyArticle(rawObject)) {
        throw new Error("Articles are not supported for diagram rendering");
    }

    try {
        const itemData = parsePerseusItem(diagram);

        // Validate that we only have interactive-graph widgets
        const widgets = itemData.question.widgets;
        const widgetTypes = Object.values(widgets).map((widget) => widget.type);

        if (widgetTypes.length === 0) {
            throw new Error(
                "No widgets found. Expected interactive-graph widgets.",
            );
        }

        const nonInteractiveGraphWidgets = widgetTypes.filter(
            (type) => type !== "interactive-graph",
        );

        if (nonInteractiveGraphWidgets.length > 0) {
            throw new Error(
                `Only interactive-graph widgets are supported. Found: ${nonInteractiveGraphWidgets.join(", ")}`,
            );
        }

        return itemData;
    } catch (e) {
        // Re-throw validation errors, return null for parsing errors
        if (
            e instanceof Error &&
            (e.message.includes(
                "Only interactive-graph widgets are supported",
            ) ||
                e.message.includes("No widgets found"))
        ) {
            throw e;
        }
        return null;
    }
}
